import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Avatar, Collapse, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { useAppSelector } from 'app/config/store';
import MenuItem from 'app/shared/layout/menus/menu-item';
import React from 'react';
import { Translate } from 'react-jhipster';

export interface IAccountMenu {
  isAuthenticated: boolean;
  index: number;
  onExpand: (index: number) => void;
  isExpanded: boolean;
  setOpen: (value: boolean) => void;
  drawerIsOpen: boolean;
}

export const AccountMenu = (props: IAccountMenu) => {
  const account = useAppSelector(state => state.authentication.account);

  return (
    <>
      <Tooltip title={props.drawerIsOpen ? '' : <Translate contentKey="global.menu.account.main">Account</Translate>} placement="right">
        <ListItemButton
          onClick={() => props.onExpand(props.index)}
          sx={{
            pl: { xs: '10px', md: '22px' },
          }}
        >
          <ListItemIcon>
            <Avatar
              src={`data:${account.imageContentType};base64,${account.image}`}
              sx={{
                marginRight: '27px',
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary={account.firstName + ' ' + account.lastName}
            primaryTypographyProps={{
              fontWeight: props.isExpanded ? '600' : '400',
              fontSize: '14px',
              display: 'inline',
            }}
            sx={{
              opacity: open ? 1 : 0,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          />
          {props.isExpanded ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </Tooltip>

      <Collapse in={props.isExpanded} timeout="auto" unmountOnExit>
        <List component="div" disablePadding onClick={() => props.setOpen(false)}>
          <MenuItem icon="asterisk" to="/account/settings">
            <Translate contentKey="global.menu.account.settings">Settings</Translate>
          </MenuItem>
          <MenuItem icon="asterisk" to="/account/password">
            <Translate contentKey="global.menu.account.password">Password</Translate>
          </MenuItem>
        </List>
      </Collapse>
    </>
  );
};
